import { Action, configureStore } from "@reduxjs/toolkit";
import rootReducer, { RootState } from "./reducer";
import thunk, { ThunkAction } from "redux-thunk";

const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
  devTools: true,
});

export type AppDispatch = typeof store.dispatch;
export const dispatch = store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;

export default store;
